<template lang="pug">
  GlobalDialog(
    v-model="dialog"
    :headerTitle="$t('efficiency.createReport')"
    scrollable
    :showMButton="true"
    :mButtonIsOutlined='true'
    :m-button-title="$t('efficiency.reset')"
    :l-button-title="$t('commonWords.cancel')"
    :r-button-title="$t('commonWords.create')"
    max-width="60%"
    mButtonTextColor='#FE544F'
    mButtonColor='#FE544F'
    mButtonIsOutlined
    lButtonStyle="padding: 0"
    toolbar-padding="padding: 0px !important;"
    buttonSectionPadding="padding: 0 20px 30px;"
    @clickRButton="createReport"
    @clickMButton="clearFields"
    @clickLButton="dialog = false"
  )
    template(slot='content')
      v-form(
        ref="reportsForm"
      )
        span.text-sizing {{$t('efficiency.reportInfoLabel')}}
        v-text-field(
          v-model="report.name"
          :label="$t('efficiency.reportName')"
          filled
          dense
          :error-messages="inputErrorMessage"
          :rules="[ rules.required, rules.uniqueName ]"
        )
        span.text-sizing {{$t('efficiency.searchMessageLabel')}}
        v-select(
          v-model="report.businessArea"
          :label="$t('efficiency.reportBusinessArea')"
          filled
          :items="items.businessAreas"
          dense
          :rules="[ rules.minLength]"
          multiple
        ).input-spacings
        v-select(
          v-model="report.theme"
          :label="$t('efficiency.reportTheme')"
          :items="items.themes"
          filled
          dense
          :rules="[ rules.minLength]"
          multiple
        ).input-spacings
        v-select(
          v-model="report.subTheme"
          :label="$t('efficiency.reportSubTheme')"
          :items="items.subThemes"
          filled
          dense
          :rules="[ rules.minLength]"
          multiple
        ).input-spacings
        span.text-sizing {{$t('efficiency.searchMessageDate')}}
        v-row(align="center").data-spacings
          v-menu.menu-style(
            v-model='menu1',
            :close-on-content-click='false'
            transition='scale-transition'
            offset-x
            :nudge-bottom="nudgeBottomHeight"
            max-width='290px'
            min-width='auto'
            )
            template(v-slot:activator='{ on, attrs }')
              v-text-field(
                v-model='computedDate1Formatted',
                :error='error1',
                :label='$t("dateInterval.startDate")'
                v-mask='fieldMask'
                hint="DD/MM/AAAA - HH:MM"
                persistent-hint
                prepend-icon='event'
                v-bind='attrs'
                v-on='on')
            v-date-picker(
              v-if='panel1 === "date"'
              v-model='dInterval.d1',
              :max='dInterval.d2'
              :locale='checkDefaultLanguage'
              color='#9c27b0'
              @input='inputPanel("1", "date")')
            v-time-picker(
              v-if='panel1 === "time"'
              v-model='dInterval.t1'
              flat
              format='24hr',
              :max='dInterval.d1 === dInterval.d2 ? dInterval.t2 : null'
              @click:minute='written1 = false; error1 = false'
              color='#9c27b0'
              scrollable)
              div(style='flex-grow: 1 !important')
              v-btn(text color='#1867c0' @click='panel1 = "date"') {{ $t("dateInterval.toGoBack") }}
              v-btn(text color='#1867c0' @click='inputPanel("1", "time")') OK
          span.text-sizing {{$t('dateInterval.upUntil')}}
          v-menu.menu-style(
            v-model='menu2',
            :close-on-content-click='false'
            transition='scale-transition'
            offset-x
            :nudge-bottom="nudgeBottomHeight"
            max-width='290px'
            min-width='auto')
            template(v-slot:activator='{ on, attrs }')
              v-text-field(
                v-model='computedDate2Formatted',
                :error='error2',
                :label='$t("dateInterval.endDate")'
                v-mask='fieldMask'
                hint="DD/MM/AAAA - HH:MM"
                persistent-hint
                prepend-icon='event'
                v-bind='attrs'
                v-on='on')
            v-date-picker(
              v-if='panel2 === "date"'
              v-model='dInterval.d2',
              :min='dInterval.d1'
              :locale='checkDefaultLanguage'
              color='#9c27b0'
              @input='inputPanel("2", "date")')
            v-time-picker(
              v-if='panel2 === "time"'
              v-model='dInterval.t2'
              flat
              format='24hr',
              :min='dInterval.d1 === dInterval.d2 ? dInterval.t1 : null'
              @click:minute='written2 = false; error2 = false'
              color='#9c27b0'
              scrollable)
              div(style='flex-grow: 1 !important')
              v-btn(text color='#1867c0' @click='panel2 = "date"') {{ $t("dateInterval.toGoBack") }}
              v-btn(text color='#1867c0' @click='inputPanel("2", "time")') OK
</template>

<script>
import GlobalDialog from '@/components/Reuse/GlobalDialog.vue'
import { mask } from 'vue-the-mask'
import { selectedLocale } from '@/plugins/i18n'
import moment from 'moment'
import Swal from 'sweetalert2'
import debounce from 'lodash.debounce'

const mockedBusinessAreas = [
  { text: 'oráculo', value: 'oráculo' },
  { text: 'Jornada do Colaborador - HTR', value: 'Jornada do Colaborador - HTR' },
  { text: 'HESQ', value: 'HESQ' },
  { text: 'Jornada do Cliente - OTC', value: 'Jornada do Cliente - OTC' },
  { text: 'Jornada do Fornecedor - PTP', value: 'Jornada do Fornecedor - PTP' },
  { text: 'Facilities - FAC', value: 'Facilities - FAC' },
  { text: 'Jornada da Informação - RTR', value: 'Jornada da Informação - RTR' },
  { text: 'Jornada do Cliente', value: 'Jornada do Cliente' },
  { text: 'Jornada Corporativo', value: 'Jornada Corporativo' }
]
const mockedThemes = [
  { text: 'Colmeya', value: 'Colmeya' },
  { text: 'Consultar Chamados do Usuario', value: 'Consultar Chamados do Usuario' },
  { text: 'Saúde e bem-estar', value: 'Saúde e bem-estar' },
  { text: 'Central de Serviços', value: 'Central de Serviços' },
  { text: 'Saúde e Bem Estar', value: 'Saúde e Bem Estar' },
  { text: 'Download de Jornada do Cliente', value: 'Download de Jornada do Cliente' },
  { text: 'Termômetro', value: 'Termômetro' },
  { text: 'Férias', value: 'Férias' },
  { text: 'Download Documento Cliente', value: 'Download Documento Cliente' }
]
const mockedSubThemes = [
  { text: 'Canais_Atendimentos_CoE', value: 'Canais_Atendimentos_CoE' },
  { text: 'Termômetro', value: 'Termômetro' },
  { text: 'Consultar Chamados CoE', value: 'Consultar Chamados CoE' },
  { text: 'Reembolso_Geral', value: 'Reembolso_Geral' },
  { text: 'Realizar Download Nota Fiscal', value: 'Realizar Download Nota Fiscal' },
  { text: 'Download_PDF_Cliente_Pedido', value: 'Download_PDF_Cliente_Pedido' },
  { text: 'Agendamento e Alteração de Férias', value: 'Agendamento e Alteração de Férias' }
]

export default {
  name: 'CreateAbandonmentReportsModal',
  components: {
    GlobalDialog
  },
  directives: { mask },
  props: {
    displayModal: {
      type: Boolean,
      default: false
    },
    reports: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      fieldMask: '##/##/#### - ##:##',
      startDate: undefined,
      endDate: undefined,
      inputErrorMessage: '',
      dInterval: {
        d1: null,
        t1: null,
        d2: null,
        t2: null
      },
      menu1: false,
      menu2: false,
      error1: false,
      error2: false,
      panel1: 'date',
      panel2: 'date',
      written1: false,
      written2: false,
      selectedLocale: selectedLocale,
      items: {
        businessAreas: mockedBusinessAreas,
        themes: mockedThemes,
        subThemes: mockedSubThemes
      },
      report: {
        name: '',
        to: '',
        from: '',
        theme: [],
        subTheme: [],
        businessArea: []
      },
      rules: {
        minLength: v => v.length > 0 || this.$t('efficiency.atLeastOne'),
        required: v => !!v || this.$t('efficiency.reportNameIsRequired'),
        uniqueName: v => this.validateIfNameIsUnique(v) || this.$t('efficiency.reportNameAlreadyExists')
      }
    }
  },
  created () {
    this.dInterval = {
      d1: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      d2: moment().format('YYYY-MM-DD'),
      t1: moment().set({ hours: 0, minutes: 0, seconds: 0 }).format('HH:mm'),
      t2: moment().set({ hours: 23, minutes: 59, seconds: 59 }).format('HH:mm')
    }
  },
  computed: {
    nudgeBottomHeight () {
      const currentWindowSize = window.innerWidth
      return -currentWindowSize * 0.15
    },
    dialog: {
      set () {
        this.$emit('close')
      },
      get () {
        return this.displayModal
      }
    },
    computedDate1Formatted: {
      get: function () {
        return `${this.formatDate(this.dInterval.d1)} - ${
          this.dInterval.t1 === null ? '00:00' : this.dInterval.t1
        }`
      },
      set: function (nV) {
        this.written1 = nV
      }
    },
    computedDate2Formatted: {
      get: function () {
        return `${this.formatDate(this.dInterval.d2)} - ${
          this.dInterval.t2 === null ? '23:59' : this.dInterval.t2
        }`
      },
      set: function (nV) {
        this.written2 = nV
      }
    }
  },
  methods: {
    clearFields () {
      this.report = {
        name: '',
        to: '',
        from: '',
        theme: [],
        subTheme: [],
        businessArea: []
      }
      this.inputErrorMessage = ''
      this.dInterval = {
        d1: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        d2: moment().format('YYYY-MM-DD'),
        t1: moment().set({ hours: 0, minutes: 0, seconds: 0 }).format('HH:mm'),
        t2: moment().set({ hours: 23, minutes: 59, seconds: 59 }).format('HH:mm')
      }
      this.$refs.reportsForm.reset()
    },
    validateIfNameIsUnique: debounce(
      async function (value) {
        this.inputErrorMessage = ''
        try {
          await
          this.$axios.get(`${process.env.VUE_APP_REPORTS_BACKEND}/reports/abandonmentReports/validate?reportName=${encodeURIComponent(this.report.name)}`)
        } catch (e) {
          this.inputErrorMessage = this.$t('efficiency.reportNameAlreadyExists')
        }
      }, 500),
    close () {
      this.$emit('close')
    },
    loadLocaleMessages () {
      const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
      const validations = require.context('vee-validate/dist/locale', true, /[A-Za-z0-9-_,\s]+\.json$/i)
      const messages = {}
      locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
          const locale = matched[1]
          messages[locale] = locales(key)
          const validationsKey = key.replace(/-/g, '_')
          messages[locale].validations = validations(validationsKey).messages
        }
      })
      return messages
    },
    checkDefaultLanguage () {
      let matched = null
      let languages = Object.getOwnPropertyNames(this.loadLocaleMessages())
      languages.forEach((lang) => {
        if (lang === navigator.language) {
          matched = lang
        }
      })
      if (!matched) {
        languages.forEach((lang) => {
          let languagePartials = navigator.language.split('-')[0]
          if (lang === languagePartials) {
            matched = lang
          }
        })
      }
      if (!matched) {
        languages.forEach((lang) => {
          let languagePartials = navigator.language.split('-')[0]
          if (lang.split('-')[0] === languagePartials) {
            matched = lang
          }
        })
      }
      return matched
    },
    createReport () {
      // If the user hasn't written or selected a time, by default it's 00:00 and 23:59
      let time1 = this.written1
        ? this.written1.substr(13, 5) || '00:00'
        : this.dInterval.t1 || '00:00'
      let time2 = this.written2
        ? this.written2.substr(13, 5) || '23:59'
        : this.dInterval.t2 || '23:59'
      this.dInterval.t1 = time1
      this.dInterval.t2 = time2

      try {
        const isRefsFormValid = this.$refs.reportsForm.validate()
        if (isRefsFormValid) {
          this.$axios.post(`${process.env.VUE_APP_REPORTS_BACKEND}/reports/abandonmentReports`, {
            name: this.report.name,
            theme: this.report.theme,
            subTheme: this.report.subTheme,
            businessArea: this.report.businessArea,
            to: this.mountDateTime(this.dInterval.d2, this.dInterval.t2, '59'),
            from: this.mountDateTime(this.dInterval.d1, this.dInterval.t1, '00')
          })
            .then(() => {
              this.$emit('reportCreated')
              this.dialog = false
            })
        }
      } catch (e) {
        Swal.fire({
          icon: 'error',
          title: this.$t('snapshots.thereWasAnErrorInYourRequest')
        })
      }
    },
    mountDateTime (d, t, seconds) {
      return moment.utc(`${d}T${t}:${seconds}`).format('YYYY-MM-DD[T]HH:mm:ss')
    },
    formatDate (date) {
      if (!date) return null
      return moment(date).locale(selectedLocale).format('L')
    },
    onClose1 () {
      this.menu1 = false
      this.panel1 = 'date'
    },
    onClose2 () {
      this.menu2 = false
      this.panel2 = 'date'
    },
    inputPanel (field, panel) {
      if (field === '1') {
        if (panel === 'date') {
          this.panel1 = 'time'
          this.dInterval.t2 = null
        }
        if (panel === 'time') {
          this.error1 = false
          this.written1 = false
          this.onClose1()
        }
      } else if (field === '2') {
        if (panel === 'date') {
          this.panel2 = 'time'
          // this.dInterval.d1 = this.dInterval.d2
        }
        if (panel === 'time') {
          this.error2 = false
          this.written2 = false
          this.onClose2()
        }
      }
    }
  },
  watch: {
    menu1 (nV) {
      if (!nV) {
        this.onClose1()
      }
    },
    menu2 (nV) {
      if (!nV) {
        this.onClose2()
      }
    }
  }

}
</script>

<style lang="scss" scoped>
::v-deep .v-list-item__title {
  font-weight: 300 !important;
}

.text-sizing {
  font-size: 16px;
}

.data-spacings {
  max-width: 50%;
  padding-top: 10px;
  margin-left: -2px;
  display: flex;
  justify-content: space-between;

  ::v-deep .v-input {
    max-width: 183px;
  }
}

.input-spacings {
  ::v-deep .v-text-field__details {
    display: none;
  }

  ::v-deep.v-text-field .v-label--active {
    transform:
      translateY(-30px)
      translateX(-18px)scale(.75) !important;
  }

  ::v-deep .v-select__selection--comma {
    font-weight: 300 !important;
  }

  ::v-deep .v-input__control {
    margin-bottom: 10px !important;
  }
}
</style>
